import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ToasterService } from "angular2-toaster";
import { ModalDirective } from "ngx-bootstrap/modal";
import { GenericValidator } from "src/app/_classes/generic.form.validator";
import { EmpresaECentroDestino } from "src/app/_models/empresa-e-centro-destino";
import { EtiquetaMarcopolo } from "src/app/_models/etiqueta-marcopolo";
import { PedidoDeCompra } from "src/app/_models/pedido-de-compra";
import { RegistrarEtiquetaMarcopoloDTO } from "src/app/_models/registar-etiqueta-marcopolo-dto";
import { LoadingService } from "src/app/_services/local/loading.service";
import { EtiquetasMarcopoloService } from "src/app/_services/madu-api/etiquetas-marcopolo.service";

@Component({
    selector: 'app-etiquetas-marcopolo',
    templateUrl: './etiquetas-marcopolo.component.html'
})
export class EtquetasMarcopoloComponent implements OnInit {
    @ViewChild('etiquetasModal') public etiquetasModal: ModalDirective;
    @ViewChild('arquivoXML')

    set setarquivoXM(fileInputRef: ElementRef) {
        this.arquivoXML = <HTMLInputElement>fileInputRef.nativeElement;
    };
    private arquivoXML: HTMLInputElement;

    errors: any = [];
    arquivoXMLForm: FormGroup;
    pedidosDeCompra: PedidoDeCompra[];
    paramentroPaginacao: number = 60;
    filtrarPedidosDeComprasForm: FormGroup;
    etiquetasForm: FormGroup;
    private validationMessages: { [key: string]: { [key: string]: string } };
    displayMessage: { [key: string]: string } = {};
    private genericValidator: GenericValidator;
    empresasECentrosDestino: EmpresaECentroDestino[] = [];
    registraEtiquetaDTO: RegistrarEtiquetaMarcopoloDTO;
    etiquetasPorPedidoDeCompra: EtiquetaMarcopolo[] = [];

    etiqueta: EtiquetaMarcopolo | null = null;
    larguraDaEtiqueta: number | null = null;
    alturaDaEtiqueta: number | null = null;

    constructor(private fb: FormBuilder,
        private toasterService: ToasterService,
        private loadingService: LoadingService,
        private etiquetasMarcopoloService: EtiquetasMarcopoloService) {

        this.validationMessages = {
            xmlBodyMarcopoloId: {
                required: 'xmlBodyMarcopoloId é obrigatória.'
            },
            empresaECentroDestinoId: {
                required: 'Planta é obrigatória.'
            },
            numNFe: {
                required: 'A NFe é obrigatório.'
            },
            volume: {
                required: 'A volume é obrigatório.'
            },
            qtd: {
                required: 'A qtd da é obrigatória.'
            }
        };

        this.genericValidator = new GenericValidator(this.validationMessages);

        this.arquivoXMLForm = this.fb.group({
            arquivoXML: ''
        });

        this.filtrarPedidosDeComprasForm = this.fb.group({
            pedidoCompra: '',
            itemPedidoDeCompra: ''
        });

        this.etiquetasForm = this.fb.group({
            xmlBodyMarcopoloId: ['', Validators.required],
            empresaECentroDestinoId: ['', Validators.required],
            numNFe: ['', Validators.required],
            volume: ['', Validators.required],
            qtd: ['', Validators.required]
        });
    }

    ngOnInit(): void {
        this.obterPedidosdeVenda();
        this.obterEmpresasECentrosDestino();
    }

    obterEmpresasECentrosDestino() {
        this.etiquetasMarcopoloService.getEmpresasECentrosDestino().subscribe(
            result => { this.empresasECentrosDestino = result; },
            error => { this.onError(error); }
        );
    }

    limparFormRegistarXML() {
        this.arquivoXMLForm.reset({
            arquivoXML: ''
        });
    }

    limparFormFiltros() {
        this.filtrarPedidosDeComprasForm.reset({
            pedidoCompra: '',
            itemPedidoDeCompra: ''
        });
    }

    limparFormEtqiuetaExetoXmlBodyMarcopoloId() {
        let idXmlAtual = this.etiquetasForm.get('xmlBodyMarcopoloId').value;
        this.etiquetasForm.reset({
            xmlBodyMarcopoloId: idXmlAtual,
            empresaECentroDestinoId: '',
            numNFe: '',
            volume: '',
            qtd: ''
        });
    }

    limparFormEtqiueta() {
        this.etiquetasForm.reset({
            xmlBodyMarcopoloId: '',
            empresaECentroDestinoId: '',
            numNFe: '',
            volume: '',
            qtd: ''
        });
    }

    registrarXML() {

        this.errors = [];

        this.loadingService.showLoading(true);

        console.log(this.arquivoXML);

        if (!this.checarCargaDeArquivoXML(this.arquivoXML)) return;

        this.etiquetasMarcopoloService.registrarArquivoXMLMarcopolo(this.arquivoXML).subscribe(
            result => {
                console.log(result);
                this.toasterService.pop('success', ':)', 'Tudo certo, arquivo XML registrado!');
                this.loadingService.showLoading(false);
                this.obterPedidosdeVenda();
                this.limparFormRegistarXML();
            },
            error => { this.onError(error); });
    }

    exibirEtiquetas(xmlBodyMarcopoloId: string) {
        this.errors = [];
        this.limparFormEtqiueta();
        console.log(xmlBodyMarcopoloId);
        this.etiquetasForm.get('xmlBodyMarcopoloId').setValue(xmlBodyMarcopoloId);
        console.log(this.etiquetasForm);
        this.obterEtiquetasRegistradas();
        this.etiquetasModal.show();
    }

    checarCargaDeArquivoXML(imagem: HTMLInputElement): boolean {
        if (imagem.files.length == 0) {
            this.toasterService.pop('error', ':|', 'Selecione uma foto antes de Salvar!!!');
            this.loadingService.showLoading(false);
            return false;
        }
        return true;
    }

    private onError(error) {
        this.loadingService.clearShowLoading();
        console.log(error);
        if (error.errors != null) {
            this.errors = error.errors;
            this.toasterService.pop('error', 'Opa :(', 'Algo deu errado!');
        }
    }

    btnPaginacao() {
        this.paramentroPaginacao += 100;
        this.obterPedidosdeVenda();
    }

    obterPedidosdeVenda() {
        this.loadingService.showLoading(true);
        this.etiquetasMarcopoloService.getPedidosDeCompraDisponiveis(this.paramentroPaginacao, this.filtrarPedidosDeComprasForm.value['pedidoCompra'], this.filtrarPedidosDeComprasForm.value['itemPedidoDeCompra'])
            .subscribe(
                result => {
                    console.log(result);
                    this.pedidosDeCompra = result;
                    this.loadingService.showLoading(false);
                },
                error => { this.onError(error); }
            )
    }

    registrarEtiqueta() {
        this.displayMessage = this.genericValidator.processMessages(this.etiquetasForm);
        console.log(this.displayMessage);
        console.log(this.etiquetasForm.value);
        if (this.etiquetasForm.dirty && this.etiquetasForm.valid) {
            let p = Object.assign({}, this.registraEtiquetaDTO, this.etiquetasForm.value)
            console.log(p);
            this.loadingService.showLoading(true);
            this.etiquetasMarcopoloService.registrarEtiqueta(p)
                .subscribe(
                    result => {
                        console.log(result);
                        this.toasterService.pop('success', ':)', 'Tudo certo, etiqueta registrada!');
                        this.loadingService.showLoading(false);
                        this.obterEtiquetasRegistradas();
                        this.limparFormEtqiuetaExetoXmlBodyMarcopoloId();
                    },
                    error => { this.onError(error) });
        }
    }

    imprimirEtiqueta(etiqueta, largura, altura) {
        this.etiqueta = etiqueta;
        this.larguraDaEtiqueta = largura;
        this.alturaDaEtiqueta = altura;
    }

    fecharModalDaEtiqueta(): void {
        this.etiqueta = null;
        this.larguraDaEtiqueta = null;
        this.alturaDaEtiqueta = null;
    }

    removerEtiqueta(etiqueta) {

    }

    obterEtiquetasRegistradas() {
        this.etiquetasMarcopoloService.getEtiquetasPorXMLBodyMarcopoloId(this.etiquetasForm.get('xmlBodyMarcopoloId').value).subscribe(
            result => { this.etiquetasPorPedidoDeCompra = result; },
            error => { this.onError(error); }
        );
    }
}
